// Extract context and hook from Provider to fix Lint warning about fast refresh
import { createContext, useContext } from 'react';
import { EventMembership } from '@type/db-types';
import { EventWithMembership } from '@modules/supabase/events';
import { StripeAccountContextValues } from '@hooks/useStripeAccount';

export interface EventContextValues {
    loading: boolean;
    event: EventWithMembership | null;
    isEventAdmin: boolean;
    membership: EventMembership | Partial<EventMembership> | null | undefined;
    registrationCount: number | null;
    stripePaymentUser: { stripeId: string; userId: string } | null;
    stripeState: StripeAccountContextValues | null;
}

export const EventContext = createContext<EventContextValues>({
    loading: true,
    event: null,
    isEventAdmin: false,
    membership: undefined,
    registrationCount: null,
    stripePaymentUser: null,
    stripeState: {} as StripeAccountContextValues,
});

// Access auth context values and functions
const useEventContext = () => {
    const ctx = useContext(EventContext);

    if (!ctx) console.error('useEventContext called outside of EventProvider Context');

    return ctx;
};

export default useEventContext;
